import { getOpenIdConnectEndpoint } from '@/utils/endpoint'

export const oidcSettings = {
  authority: getOpenIdConnectEndpoint() || 'https://localhost:8000',
  clientId: 'web.pkce',
  redirectUri: `${window.location.origin}/auth`,
  responseType: 'code',
  scope: 'openid profile email offline_access vs_webapi',
  automaticSilentRenew: true,
  automaticSilentSignin: false,
  silentRedirectUri: window.location.origin
}
